import {
  REFERENCE_DETAIL_FETCH,
  REFERENCE_DETAIL_SUCCESS,
  REFERENCE_DETAIL_FAILURE
} from './actionTypes';

const initialState = {
  isLoaded: false,
  error: []
};

export const referenceDetailReducer = (state = initialState, action) => {
  switch (action.type) {
    case REFERENCE_DETAIL_FETCH:
      return { ...state, isLoaded: false };
    case REFERENCE_DETAIL_SUCCESS:
      return { ...state, isLoaded: true };
    case REFERENCE_DETAIL_FAILURE:
      return {
        ...state,
        error: action.payload
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/ReferenceDetail/reducer.js